import { render, staticRenderFns } from "./SkillGroup.vue?vue&type=template&id=633ed318&scoped=true&"
import script from "./SkillGroup.vue?vue&type=script&lang=js&"
export * from "./SkillGroup.vue?vue&type=script&lang=js&"
import style0 from "./SkillGroup.vue?vue&type=style&index=0&id=633ed318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633ed318",
  null
  
)

export default component.exports